import { uniq } from "lodash";
import { Machine } from "../../machines/shared/models/machine";
import { MachineConfiguration } from "../../machines/shared/models/machineConfiguration";
import { Record } from "../../records/server/crud";
import { ServiceResponse } from "../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementServiceProvider,
} from "../../ui/authorizedUiElement";
import { vsProviderName as machineDetailTabsServiceProviderName } from "../../machines/shared/components/views/machines/detail/tabs";
import { vsName as ReportingServerName } from "../../reporting/server";

import { vsComponentName as machineProgressiveMeterReadingComponentName } from "../../machines/common/Pages/detail/progressiveMeterReadings";

import { vsComponentName as machineDetailConfigurationComponentName } from "../components/machineDetailConfiguration";

export function machineDetailTabsConfig() {
  return [
    machineDetailTabsServiceProviderName,
    (
      machineDetailTabsServiceProvider: AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig>
    ) => {
      machineDetailTabsServiceProvider
        .addElement({
          displayName: "Progressive Meter Readings",
          id: "progressiveReadings",
          uiSrefFragment: "progressiveReadings",
          requiredPermission: "machines.progressives.read",
          stateDefinition: {
            url: "/progressiveReadings",
            component: machineProgressiveMeterReadingComponentName,
          },
        })
        .addElement({
          displayName: "Progressive Configuration",
          id: "progressiveConfiguration",
          uiSrefFragment: "progressiveConfiguration",
          requiredPermission: "machines.progressives.read",
          stateDefinition: {
            url: "/progressiveConfiguration",
            component: machineDetailConfigurationComponentName,
            resolve: {
              progressiveReportGroup: [
                ReportingServerName,
                function (reportingServer: any) {
                  return reportingServer.getReportGroup("progressives");
                },
              ],
              progressiveDefinitionMachines: [
                ServerUtilityName,
                "machine",
                (
                  serverUtility: ServerUtility,
                  machine: Machine<MachineConfiguration>
                ) =>
                  serverUtility.fetchAllWrapped({
                    url: "/api/machines/progressives/ProgressiveDefinitionMachine/structured",
                    query: {
                      MachineId: machine.Id,
                    },
                  }),
              ],
              progressiveDefinitions: [
                "progressiveDefinitionMachines",
                ServerUtilityName,
                (
                  progressiveDefinitionMachines: Record[],
                  serverUtility: ServerUtility
                ) => {
                  const progressiveDefinitionIds = uniq(
                    progressiveDefinitionMachines.map(
                      (m) => <number>m.ProgressiveDefinitionId
                    )
                  );
                  return serverUtility
                    .sendApiRequest<ServiceResponse<Record[]>>({
                      url: "/api/machines/progressives/ProgressiveDefinition/byIds",
                      method: "get",
                      params: {
                        Ids: progressiveDefinitionIds,
                      },
                    })
                    .then((r) => r.Result);
                },
              ],
              date: ["environment", (env: { Date: Date }) => env.Date],
            },
          },
        });
    },
  ];
}
